import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ListBrands } from '@/state/brands/models'
import { RoleType, SidebarId, TwoFactorStatus } from '@/enums'

import { ApplicationState } from '@/state/root.models'
import { AuthState, UserSession, LoginResponse } from '../models'
import getLoggedInUserExtraReducer from '../thunk/get-logged-in.thunk'

/**
 * SET INITIAL AUTH STATE
 */
export const initialState: AuthState = {
  token: '',
  unauthorized: true,
  isLoading: false,
  hasError: false,
  error: '',
  wasDeleted: false,
  userSession: {
    id: '',
    username: '',
    role: RoleType.SUPER_ADMIN,
    iat: 0,
    exp: 0,
  },
  sidebarIds: [],
  brand: { name: '', id: 0, siteId: 0, enable: false, currencies: [] },
  twoFactorStatus: TwoFactorStatus.INITIAL,
  twoFactorPID: -1,
  loggedUser: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginActionSuccess(state, action: PayloadAction<LoginResponse>) {
      state.isLoading = false
      state.token = action.payload.accessToken
    },
    removeTokenAction(state) {
      state.token = undefined
    },
    setUserSessionAction(state, action: PayloadAction<UserSession>) {
      // TODO: This is a hack to see the content as SUPER_ADMIN.
      state.userSession = { ...action.payload, role: RoleType.SUPER_ADMIN }
    },
    setUnauthorizedAction(state, action: PayloadAction<boolean>) {
      state.unauthorized = action.payload
    },
    setSidebarIdsAction(state, action: PayloadAction<SidebarId[]>) {
      state.sidebarIds = action.payload
    },
    setRefreshTokenAction(state, action: PayloadAction<string>) {
      state.token = action.payload
    },
    setSelectBrandAction(state, action: PayloadAction<ListBrands>) {
      state.brand = action.payload
    },
    setTwoFactorStatusAction(state, action: PayloadAction<TwoFactorStatus>) {
      state.twoFactorStatus = action.payload
    },
    setTwoFactorPIDAction(state, action: PayloadAction<number>) {
      state.twoFactorPID = action.payload
    },
    setTwoFactorVerified(state, action: PayloadAction<boolean>) {
      state.loggedUser.twoFactorAuthActive = action.payload
    },
    resetLoggedInUserStateAction(state, action: PayloadAction<undefined>) {
      state.loggedUser = initialState.loggedUser
    },
    resetAuthLogoutAction(state) {
      state.token = undefined
      state.twoFactorStatus = TwoFactorStatus.INITIAL
      state.twoFactorPID = -1
    },
  },
  extraReducers: (builder) => {
    getLoggedInUserExtraReducer(builder)
  },
})

export const {
  loginActionSuccess,
  setSelectBrandAction,
  setRefreshTokenAction,
  setUserSessionAction,
  setSidebarIdsAction,
  setUnauthorizedAction,
  removeTokenAction,
  setTwoFactorStatusAction,
  setTwoFactorPIDAction,
  setTwoFactorVerified,
  resetAuthLogoutAction,
  resetLoggedInUserStateAction,
} = authSlice.actions

export const authSelector = ({ auth }: ApplicationState) => auth

export default authSlice
